module.exports = "/images/bg_everest22_new.jpg?3babe7876bdb635cf2109d88bcf65e9f";